import Vue from 'vue'
import VueRouter from 'vue-router'
import store from '@/store' // or use a full path to ./store
import reset from '../store/index.js'

Vue.use(VueRouter)

const routes = [{
        path: '/',
        redirect: 'login',
    },
    {
        path: '/dashboard',
        name: 'dashboard',
        component: () =>
            import ('@/views/tickcats/dashboard.vue'),
    },
    {
        path: '/users',
        name: 'users',
        component: () =>
            import ('@/views/tickcats/users.vue'),
    },
    {
        path: '/users/add',
        name: 'user_add',
        component: () =>
            import ('@/views/tickcats/user_add.vue'),
    },
    {
        path: '/users/detail/:id',
        name: 'user_detail',
        component: () =>
            import ('@/views/tickcats/user_detail.vue'),
    },
    {
        path: '/organizer',
        name: 'organizer',
        component: () =>
            import ('@/views/tickcats/organizer.vue'),
    },
    {
        path: '/organizer/add',
        name: 'organizer_add',
        component: () =>
            import ('@/views/tickcats/organizer_add.vue'),
    },
    {
        path: '/organizer/detail/:id',
        name: 'organizer_detail',
        component: () =>
            import ('@/views/tickcats/organizer_detail.vue'),
    },
    {
        path: '/coupons',
        name: 'coupons',
        component: () =>
            import ('@/views/tickcats/coupons.vue'),
    },
    {
        path: '/coupon/add',
        name: 'coupon_add',
        component: () =>
            import ('@/views/tickcats/coupon_add.vue'),
    },
    {
        path: '/coupon/detail/:id',
        name: 'coupon_detail',
        component: () =>
            import ('@/views/tickcats/coupon_detail.vue'),
    },
    {
        path: '/events',
        name: 'events',
        component: () =>
            import ('@/views/tickcats/events.vue'),
    },
    {
        path: '/events/add',
        name: 'event_add',
        component: () =>
            import ('@/views/tickcats/event_add.vue'),
    },
    {
        path: '/events/detail/:id',
        name: 'event_detail',
        component: () =>
            import ('@/views/tickcats/event_detail.vue'),
    },
    {
        path: '/accesskeys',
        name: 'accesskeys',
        component: () =>
            import ('@/views/tickcats/accesskeys.vue'),
    },
    {
        path: '/accesskey/add',
        name: 'accesskey_add',
        component: () =>
            import ('@/views/tickcats/accesskey_add.vue'),
    },
    {
        path: '/accesskey/detail/:id',
        name: 'accesskey_detail',
        component: () =>
            import ('@/views/tickcats/accesskey_detail.vue'),
    },
    {
        path: '/addons',
        name: 'addons',
        component: () =>
            import ('@/views/tickcats/addons.vue'),
    },
    {
        path: '/addon/add',
        name: 'addon_add',
        component: () =>
            import ('@/views/tickcats/addon_add.vue'),
    },
    {
        path: '/addon/detail/:id',
        name: 'addon_detail',
        component: () =>
            import ('@/views/tickcats/addon_detail.vue'),
    },
    {
        path: '/orders',
        name: 'orders',
        component: () =>
            import ('@/views/tickcats/orders.vue'),
    },
    {
        path: '/order/add',
        name: 'order_add',
        component: () =>
            import ('@/views/tickcats/order_add.vue'),
    },
    {
        path: '/order/:id',
        name: 'order_detail',
        component: () =>
            import ('@/views/tickcats/order_detail.vue'),
    },
    {
        path: '/resales',
        name: 'resales',
        component: () =>
            import ('@/views/tickcats/resales.vue'),
    },
    {
        path: '/resale/:id',
        name: 'resale_detail',
        component: () =>
            import ('@/views/tickcats/resale-detail.vue'),
    },
    {
        path: '/list_events',
        name: 'list_events',
        component: () =>
            import ('@/views/tickcats/list_events.vue'),
    },
    {
        path: '/list_events/:id',
        name: 'list_event_detail',
        component: () =>
            import ('@/views/tickcats/list_event_detail.vue'),
    },
    {
        path: '/contact_us',
        name: 'contact_us',
        component: () =>
            import ('@/views/tickcats/contact_us.vue'),
    },
    {
        path: '/contact_us/:id',
        name: 'contact_us_detail',
        component: () =>
            import ('@/views/tickcats/contact_us_detail.vue'),
    },
    {
        path: '/reports',
        name: 'reports',
        component: () =>
            import ('@/views/tickcats/reports.vue'),
    },
    {
        path: '/tickettemp',
        name: 'tickettemp',
        component: () =>
            import ('@/views/tickcats/tickettemp.vue'),
    },
    {
        path: '/admins',
        name: 'admins',
        component: () =>
            import ('@/views/tickcats/admins.vue'),
    },
    {
        path: '/admins/add',
        name: 'admin_add',
        component: () =>
            import ('@/views/tickcats/admin_add.vue'),
    },
    {
        path: '/admins/detail/:id',
        name: 'admin_detail',
        component: () =>
            import ('@/views/tickcats/admin_detail.vue'),
    },
    {
        path: '/sitecontrol',
        name: 'sitecontrol',
        component: () =>
            import ('@/views/tickcats/sitecontrol.vue'),
    },
    {
        path: '/sitecontrol/add',
        name: 'sitecontrol_add',
        component: () =>
            import ('@/views/tickcats/sitecontrol_add.vue'),
    },
    {
        path: '/sitecontrol/v_add',
        name: 'sitecontrol_v_add',
        component: () =>
            import ('@/views/tickcats/sitecontrol_v_add.vue'),
    },
    {
        path: '/sitecontrol/detail/:id',
        name: 'sitecontrol_detail',
        component: () =>
            import ('@/views/tickcats/sitecontrol_detail.vue'),
    },
    {
        path: '/sitecontrol/v_detail/:id',
        name: 'sitecontrol_v_detail',
        component: () =>
            import ('@/views/tickcats/sitecontrol_v_detail.vue'),
    },
    {
        path: '/widget',
        name: 'widget',
        component: () =>
            import ('@/views/tickcats/widget.vue'),
    },
    {
        path: '/widget/add',
        name: 'widget_add',
        component: () =>
            import ('@/views/tickcats/widget_add.vue'),
    },
    {
        path: '/widget/detail/:id',
        name: 'widget_detail',
        component: () =>
            import ('@/views/tickcats/widget_detail.vue'),
    },
    {
        path: '/reports',
        name: 'Reports',
        component: () =>
            import ('@/views/pages/Reports.vue'),
        meta: {
            title: '報表',
            requireAuth: true,
        },
    },
    {
        path: '/scan',
        name: 'scan',
        component: () =>
            import ('@/views/tickcats/scan.vue'),
    },
    {
        path: '/scan-detail/:id',
        name: 'scan_detail',
        component: () =>
            import ('@/views/tickcats/scan_detail.vue'),
    },
    {
        path: '/icons',
        name: 'icons',
        component: () =>
            import ('@/views/icons/Icons.vue'),
    },
    {
        path: '/cards',
        name: 'cards',
        component: () =>
            import ('@/views/cards/Card.vue'),
    },
    {
        path: '/simple-table',
        name: 'simple-table',
        component: () =>
            import ('@/views/simple-table/SimpleTable.vue'),
    },
    {
        path: '/form-layouts',
        name: 'form-layouts',
        component: () =>
            import ('@/views/form-layouts/FormLayouts.vue'),
    },
    {
        path: '/login',
        name: 'pages-login',
        component: () =>
            import ('@/views/pages/Login.vue'),
        meta: {
            title: '登入',
            layout: 'blank',
            requireAuth: false,
        },
    },
    {
        path: '/error-404',
        name: 'error-404',
        component: () =>
            import ('@/views/Error.vue'),
        meta: {
            layout: 'blank',
        },
    },
    {
        path: '*',
        redirect: 'error-404',
    },
]

const router = new VueRouter({
    mode: 'history',
    base: process.env.BASE_URL,
    routes,
})

const DEFAULT_TITLE = ' - '

export default router